<template>
  <div class="vx-col w-full lg:w-1/4">
    <vx-card title="Pegawai Terkait" class="mt-base">
      <ul class="friend-suggesions-list">
        <li
          class="friend-suggestion flex items-center mb-4"
          v-for="(item, index) in pengguna"
          :key="index"
        >
          <div class="mr-3">
            <vs-avatar class="m-0" size="35px" :src="avatar(item)" />
          </div>
          <div class="leading-tight">
            <p class="font-medium">{{ item.nama }}</p>
            <span class="text-xs">{{ item.nama_jabatan }}</span>
          </div>
          <div class="ml-auto cursor-pointer">
            <vs-button
              radius
              type="border"
              icon-pack="feather"
              icon="icon-send"
            />
          </div>
        </li>
      </ul>
      <template slot="footer">
        <vs-button
          type="gradient"
          class="w-full mt-6"
          color="#7367F0"
          gradient-color-secondary="#CE9FFC"
          @click="
            $router.push({
              name: 'profile-bidang',
              params: { id: pengguna[0].bidang_uuid }
            })
          "
        >
          Lihat Semua
        </vs-button>
      </template>
    </vx-card>
  </div>
</template>

<script>
import { ALL_BY_BIDANG } from "@/query/pengguna";

export default {
  data() {
    return {
      pengguna: []
    };
  },
  methods: {
    avatar(item) {
      if (item.avatar !== null)
        return `${process.env.VUE_APP_DIGOF_URL}sources/${item.avatar}`;
      else
        return "https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-2/img/13-small.d796bffd.png";
    }
  },
  apollo: {
    pengguna: {
      query: ALL_BY_BIDANG,
      update: data => data.penggunaGetByBidang,
      variables() {
        return {
          jabatanId: this.$sanctum.getUser().jabatan_id,
          penggunaId: this.$sanctum.getUser().id
        };
      }
    }
  }
};
</script>
